import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import * as React from 'react';
import { Link } from '@module/mdrt-org/shared/i18n/i18n-navigation-link';
import { type UserNotification } from '@module/mdrt-org/shared/utils/data/get-user-notifications';
import SvgExternalLinkIcon from '@shared/ui-components/svgs/external-link-icon';
import { GTM_ACTION_CLICK, GTM_EVENT_NOTIFICATION_CLICK, GTM_EVENT_USER_INTERACTIONS } from '@shared/utils/constants/gtm';
import { getRelativeTime } from '@shared/utils/helpers/get-relative-time';
import { sendGtmEvent } from '@shared/utils/helpers/send-gtm-event';
import styles from './notifications-list.module.scss';
type CmsContentType = {
  markAsReadButtonLabel: string;
  markAsReadLinkLabel: string;
  newNotificationStatusLabel: string;
};
type NotificationsListItemProps = {
  cmsContent: CmsContentType;
  locale: string;
  mutate: (notification: {
    notificationId: string;
  }) => void;
  notification: UserNotification;
};
export const NotificationsListItem = t0 => {
  const $ = _c(47);
  const {
    cmsContent,
    locale,
    mutate,
    notification
  } = t0;
  let t1;
  if ($[0] !== notification.title) {
    t1 = <div className={styles["notifications-list__item-title"]}>{notification.title}</div>;
    $[0] = notification.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== notification.body) {
    t2 = <p className={styles["notifications-list__item-message"]}>{notification.body}</p>;
    $[2] = notification.body;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== locale || $[5] !== notification.publishedAtUtc) {
    t3 = getRelativeTime(notification.publishedAtUtc, locale);
    $[4] = locale;
    $[5] = notification.publishedAtUtc;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className={styles["notifications-list__item-message-time"]}>{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== notification.url) {
    t5 = notification.url && <div className={styles["notifications-list__url-icon"]}><SvgExternalLinkIcon className={styles["notifications-list__url-icon__icon"]} /></div>;
    $[9] = notification.url;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className={styles["notifications-list__item-details"]}>{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t6) {
    t7 = <div className={styles["notifications-list__item-message-container"]}><div className={styles["notifications-list__item-message-container__item-message-container-wrapper"]}>{t1}{t2}{t6}</div></div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const messageContainer = t7;
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = classNames(styles["notifications-list__item-content"], styles["notifications-list__item-content--interactive"]);
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== mutate || $[20] !== notification.id || $[21] !== notification.isRead) {
    t9 = notification.isRead ? undefined : () => {
      mutate({
        notificationId: notification.id
      });
    };
    $[19] = mutate;
    $[20] = notification.id;
    $[21] = notification.isRead;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = {
      className: t8,
      onClick: t9
    };
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const sharedProps = t10;
  const t11 = !notification.isRead;
  let t12;
  if ($[25] !== t11) {
    t12 = classNames(styles["notifications-list__item"], {
      [styles["notifications-list__item--indicator"]]: t11
    });
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== notification.title || $[28] !== notification.url) {
    t13 = () => {
      sendGtmEvent({
        action: GTM_ACTION_CLICK,
        event: GTM_EVENT_USER_INTERACTIONS,
        eventName: GTM_EVENT_NOTIFICATION_CLICK,
        label: "Notification",
        link_label: notification.title,
        link_url: notification.url || ""
      });
    };
    $[27] = notification.title;
    $[28] = notification.url;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== cmsContent.newNotificationStatusLabel || $[31] !== messageContainer || $[32] !== notification.isRead || $[33] !== notification.url || $[34] !== sharedProps) {
    t14 = notification.url ? <Link {...sharedProps} aria-describedby="mark-as-read-link-label" data-ga-exclude-tracking={true} href={notification.url} target="_blank">{!notification.isRead && <span className={styles["visually-hidden"]}>{cmsContent.newNotificationStatusLabel}</span>}{messageContainer}</Link> : notification.isRead ? <div className={styles["notifications-list__item-content"]}>{messageContainer}</div> : <button {...sharedProps} aria-describedby="mark-as-read-button-label" type="button">{!notification.isRead && <span className={styles["visually-hidden"]}>{cmsContent.newNotificationStatusLabel}</span>}{messageContainer}</button>;
    $[30] = cmsContent.newNotificationStatusLabel;
    $[31] = messageContainer;
    $[32] = notification.isRead;
    $[33] = notification.url;
    $[34] = sharedProps;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== cmsContent.markAsReadButtonLabel) {
    t15 = <span className={styles["visually-hidden"]} id="mark-as-read-button-label">{cmsContent.markAsReadButtonLabel}</span>;
    $[36] = cmsContent.markAsReadButtonLabel;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== cmsContent.markAsReadLinkLabel) {
    t16 = <span className={styles["visually-hidden"]} id="mark-as-read-link-label">{cmsContent.markAsReadLinkLabel}</span>;
    $[38] = cmsContent.markAsReadLinkLabel;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== notification.id || $[41] !== t12 || $[42] !== t13 || $[43] !== t14 || $[44] !== t15 || $[45] !== t16) {
    t17 = <li className={t12} key={notification.id} onClick={t13}>{t14}{t15}{t16}</li>;
    $[40] = notification.id;
    $[41] = t12;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  return t17;
};